export class MemberAdRequest {
    adImageId: string;
    url: string;
    adNotes: string;
    adType: number;


    constructor(adImageId: string, adNotes: string, adType: number, adUrl: string) {
        this.adImageId = adImageId;
        this.adNotes = adNotes;
        this.adType = adType;
        this.url = adUrl;
    }
}